import ServicePage from "@/components/ServicePage";

export default function Repairs() {
  return (
    <ServicePage
      type="Repairs"
      path="/repairs"
      title="Expert eBike repairs you can trust"
      subtitle="From punctures to motor diagnostics, our certified technicians get you back on the road fast."
      image="https://images.unsplash.com/photo-1675798227643-da319f8ee8f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      seoTitle="eBike Repairs — Fast, Certified Electric Bike Repair"
      seoDesc="Professional electric bike repairs by certified technicians. Punctures, brakes, motor & battery diagnostics. Book your ebike repair online at Ebikes&Gear Kent."
      cta="Book a Repair"
      intro={{
        heading: "Whatever's wrong, we'll fix it right",
        text: "Our workshop handles every kind of ebike repair — mechanical and electrical. Using genuine parts and manufacturer-approved diagnostics, we restore your bike to peak performance with a workmanship guarantee.",
      }}
      perks={["Bosch & Shimano certified", "Genuine OEM parts only", "Free diagnostic assessment", "While-you-wait minor repairs", "Workmanship guarantee", "Collection & return available"]}
      packages={{
        heading: "Common repairs",
        items: [
          { name: "Puncture repair", desc: "Tube replacement & inspection", price: "from £15" },
          { name: "Brake service", desc: "Pad replacement & bleed", price: "from £35" },
          { name: "Motor diagnostics", desc: "Full electrical health check", price: "from £45" },
          { name: "Battery testing", desc: "Cell health & capacity report", price: "from £30" },
        ],
      }}
    />
  );
}
